export default () => import(/* webpackChunkName: 'coffee/activities/membership/draw-common-beans' */ './DrawCommonBeans');
